import React, { useEffect, useState } from 'react'
import { BiomarkersChart } from '../Charts/BiomarkersChart';
import BiomarkersTable from '../Tables/BiomarkersTable';
import { PatientHeader } from './PatientFullDetailsCardComponents/PatientHeader';


export const BiomarkersCard = ({
    patient,
    biomarkers,
    feedingTimestampsForComparison,
    setFeedingTimestampsForComparison
}) => {

    return (
        
            <div className="row my-2 mx-1">
                <div className="col-lg-12">
                    <div className="w-100 rounded-3 bg-white">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <!-- Header --> */}
                                <PatientHeader
                                    index={0}
                                    feedingTimestampsForComparison={feedingTimestampsForComparison}
                                    setFeedingTimestampsForComparison={setFeedingTimestampsForComparison} />
                                {/* <!-- Content --> */}
                                {
                                    feedingTimestampsForComparison.length === 0 &&

                                    <div className="d-flex pb-3">
                                        <div className="px-4 pt-1 pb-1 w-100 d-flex align-items-stretch">
                                            <div className="chart-biomarkers-box border rounded me-3 overflow-hidden p-1 flex align-items-center justify-content-center">
                                                <p className="fw-semibold mb-2 ps-2 pt-2 text-xs">Maturation Index | <span className="text-muted">Weight (g)</span></p>
                                                <BiomarkersChart feedings={biomarkers?.feedings} conceptionDate={patient?.date_of_conception} isSquare={true} />
                                            </div>
                                            <div className="flex-1 border rounded table-biomarkers-box">
                                                <BiomarkersTable data={biomarkers?.feedings?.toReversed()} conceptionDate={patient?.date_of_conception} />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
    )
}
